// 88吃瓜后续专区 —— 头条/续集新料/时间线 数据
// 内容为热点事件后续的客观转述与整理，均基于公开信息，事件细节以官方与当事人说法为准。

export interface GuaArticle {
  id: string;
  tag: string;
  time: string;
  title: string;
  excerpt: string;
  body: string[];
  image: string;
  trust: '实锤' | '官方/本人回应' | '网友分析' | '待验证';
  recommend?: boolean;
}

export const leadStory: GuaArticle = {
  id: 'lead',
  tag: '当事人回应',
  time: '刚刚 · 更新',
  title: '88余波未平：当事一方再发声，事件走向出现新变量',
  excerpt:
    '沉寂数日后，当事一方就此前争议细节首次正面回应，并放出数条此前未公开的信息。多位网友比对后指出，新说法与此前时间线存在出入，剧情或再迎反转。',
  body: [
    '在持续数日的舆论发酵后，88事件的当事一方于今晚通过社交平台发布长文，就此前被反复讨论的几处争议细节作出正面回应。长文发布后，相关话题迅速冲上多个热搜榜，评论区在第一时间涌入大量蹲后续的网友。',
    '值得注意的是，回应中出现的几条「此前未公开」的信息，被细心网友与原时间线逐条比对，发现其中两处与此前流传的说法并不完全一致。究竟是个别表述的误差，还是暗藏新的故事线，目前仍需要更多佐证。',
    '截止发稿，事件另一方的公开账号尚未就此次回应作出表态，多个相关讨论区正处于「等反转」的高活跃状态。我们会继续跟进双方最新说法，并及时更新在下方时间线与续集新料中。',
  ],
  image:
    'https://readdy.ai/api/search-image?query=a%20warm%20flat%20editorial%20illustration%20of%20two%20vintage%20retro%20telephones%20exchanging%20a%20long%20paper%20scroll%20with%20question%20marks%20above%20them%2C%20on%20warm%20cream%20paper%20background%2C%20vermilion%20red%20and%20amber%20gold%20ink%20tones%2C%20soft%20subtle%20texture%2C%20consistent%20cozy%20newsroom%20palette%2C%20artistic%20clean%20vector%20style&width=1200&height=675&seq=gua-lead-01&orientation=landscape',
  trust: '官方/本人回应',
  recommend: true,
};

export const feedArticles: GuaArticle[] = [
  {
    id: 'a1',
    tag: '新线索',
    time: '今天 14:20',
    title: '新线索浮出：一张旧截图把讨论拉回最初起点',
    excerpt:
      '有网友挖出一张数月前的旧互动记录，认为其与88事件的关键时间点高度吻合，并据此提出「事情或比想象中更早」的推测。',
    body: [
      '就在热度有所回落的当下，一张被翻出来的旧截图再次把讨论拉回原点。截图显示的互动时间与88事件被曝出的关键节点高度接近，不少网友据此推测，矛盾的种子或许在更早之前就已埋下。',
      '不过也有理性声音提醒：仅凭一张时间模糊的截图难以形成完整证据链，具体以当事双方能提供的完整记录为准。目前该线索仍在被逐字比对中。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=a%20warm%20flat%20editorial%20illustration%20of%20a%20large%20magnifying%20glass%20hovering%20over%20scattered%20old%20paper%20documents%20and%20photograph%20prints%20on%20a%20table%2C%20on%20warm%20cream%20paper%20background%2C%20vermilion%20red%20and%20amber%20gold%20ink%20palette%2C%20cozy%20consistent%20vector%20art%20style%2C%20soft%20shadows%20and%20clean%20composition&width=720&height=540&seq=gua-feed-01&orientation=landscape',
    trust: '网友分析',
  },
  {
    id: 'a2',
    tag: '续集爆料',
    time: '今天 11:05',
    title: '所谓「续集」原是误会？多方拼图指向同一解释',
    excerpt:
      '此前被传得沸沸扬扬的「88续集预告」引发不少误会，经多方线索比对，其更可能是旧内容被二次传播所致。',
    body: [
      '连日来「88续集」的说法在多个平台刷屏，引发不少网友熬夜蹲守。但经过对原始出处的逐条核对，该说法更可能源于一段旧内容的二次传播，被截断后产生了「还有续集」的误会。',
      '目前原发布者已就部分表述作出说明，建议仍在等续集的网友先核对原始完整内容，避免被片段化信息带偏节奏。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=a%20warm%20flat%20editorial%20illustration%20of%20an%20unsealed%20red%20wax%20sealed%20envelope%20being%20opened%20with%20glowing%20light%20and%20small%20paper%20notes%20spilling%20out%2C%20on%20warm%20cream%20paper%20background%2C%20vermilion%20red%20and%20amber%20gold%20ink%20tones%2C%20cozy%20vector%20style%2C%20consistent%20warm%20palette%2C%20clean%20composition&width=720&height=540&seq=gua-feed-02&orientation=landscape',
    trust: '网友分析',
  },
  {
    id: 'a3',
    tag: '平台动态',
    time: '昨天 22:47',
    title: '话题区持续高能：相关词条热度为何久居不下',
    excerpt:
      '多个平台为事件相关词条挂出「持续高热」标识，二次讨论与二创内容不断涌现，让88事件的热度迟迟没有退潮。',
    body: [
      '通常热点事件的热度会在一段时间后自然回落，但88事件却呈现出「一波未平一波又起」的态势。多位平台运营观察者认为，持续的当事人回应、不断新增的网友线索，以及大量高质量的二创与梳理内容，共同维持了话题的热度。',
      '值得注意的是，平台也已对部分涉及隐私与未经证实的内容进行限流与清理，提醒大家追更的同时守住分寸。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=a%20warm%20flat%20editorial%20illustration%20of%20a%20large%20smartphone%20with%20many%20rising%20notification%20bubbles%20and%20a%20rising%20heat%20flame%20icon%2C%20on%20warm%20cream%20paper%20background%2C%20vermilion%20red%20and%20amber%20gold%20ink%20palette%2C%20cozy%20vector%20style%2C%20consistent%20warm%20tones%2C%20clean%20composition&width=720&height=540&seq=gua-feed-03&orientation=landscape',
    trust: '实锤',
  },
  {
    id: 'a4',
    tag: '事件反转',
    time: '昨天 16:30',
    title: '「反转来了」刷屏：关键录音内容被逐字还原',
    excerpt:
      '一段关键录音被逐步转写还原，其真实语境与此前流传的概括版大相径庭，评论区关于事件定性的讨论随之松动。',
    body: [
      '原本已被不少网友当作「盖棺定论」的录音片段，在完整版本被逐字还原后出现新的解读空间。还原结果显示，部分被广泛转发的「一句话概括」忽略了上下文，导致传播过程中的理解出现了明显偏差。',
      '这提醒我们，在网络讨论中截取片段与完整语境往往相去甚远。在另一方当事人尚未作出正式回应前，不建议基于单一片段过早定性。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=a%20warm%20flat%20editorial%20illustration%20of%20a%20balance%20scale%20seesaw%20holding%20two%20round%20chat%20speech%20bubbles%20at%20each%20end%20in%20perfect%20balance%2C%20on%20warm%20cream%20paper%20background%2C%20vermilion%20red%20and%20amber%20gold%20ink%20tones%2C%20cozy%20vector%20style%2C%20consistent%20warm%20palette%2C%20clean%20composition&width=720&height=540&seq=gua-feed-04&orientation=landscape',
    trust: '网友分析',
  },
  {
    id: 'a5',
    tag: '当事人回应',
    time: '前天 21:18',
    title: '当事一方松口：承认细节表述确有不当之处',
    excerpt:
      '面对持续发酵的讨论，当事一方在最新动态中承认此前个别表述存在不当，但坚称核心立场未变，舆情出现微妙松动。',
    body: [
      '在经过一段时间的沉默后，当事一方终于打破僵局，在动态中承认此前回应中个别措辞确有不妥之处，并为因此引发的误解表达了歉意。不过其同时强调，事件的核心立场与基本事实并未改变。',
      '这一半松口的态度，让原本泾渭分明的评论区出现了更多中间声音。舆论是否能就此降温，仍取决于后续双方是否拿出更完整的事实依据。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=a%20warm%20flat%20editorial%20illustration%20of%20a%20vintage%20retro%20microphone%20standing%20on%20a%20stage%20with%20a%20soft%20warm%20spotlight%20and%20subtle%20sound%20waves%2C%20on%20warm%20cream%20paper%20background%2C%20vermilion%20red%20and%20amber%20gold%20ink%20palette%2C%20cozy%20vector%20style%2C%20consistent%20warm%20tones%2C%20clean%20composition&width=720&height=540&seq=gua-feed-05&orientation=landscape',
    trust: '官方/本人回应',
  },
  {
    id: 'a6',
    tag: '网友争议',
    time: '三天前 09:44',
    title: '「帮理不帮亲」还是「先入为主」？评论区两极分化',
    excerpt:
      '随着细节不断增多，网友在「如何看待当事双方」上的分歧被进一步放大，两极评论在各大板块持续对峙。',
    body: [
      '事件推进到现阶段，一个明显的现象是网友的立场逐渐固化：一部分人强调「证据说话、帮理不帮亲」，另一部分则认为讨论早已偏离事实、陷入先入为主的站队。',
      '客观来看，任何一方的说法目前都还缺少完整的第三方佐证。本站建议，与其急着站队，不如先把时间线与双方说法都看全，再形成自己的判断。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=a%20warm%20flat%20editorial%20illustration%20of%20several%20overlapping%20round%20chat%20speech%20bubbles%20in%20an%20animated%20debate%20facing%20each%20other%2C%20some%20with%20question%20marks%2C%20on%20warm%20cream%20paper%20background%2C%20vermilion%20red%20and%20amber%20gold%20ink%20tones%2C%20cozy%20vector%20style%2C%20consistent%20warm%20palette%2C%20clean%20composition&width=720&height=540&seq=gua-feed-06&orientation=landscape',
    trust: '网友分析',
  },
  {
    id: 'a7',
    tag: '时间线梳理',
    time: '四天前 15:02',
    title: '一文读懂前情：88事件完整时间线已整理上线',
    excerpt:
      '为了让新蹲的网友快速补课，我们把事件从初次发酵到现阶段的所有关键节点按时间顺序整理成了完整脉络。',
    body: [
      '很多刚加入讨论的网友表示「信息太多、不知道从哪看起」。为此我们把事件从初次发酵、正式出圈、双方隔空交锋、再到现阶段的多次回应，整理成了按时间排列的完整时间线。',
      '每一条节点都标注了大致时间与事件性质，方便您快速定位。完整时间线请下拉至本站「时间线」板块查看，另有前情要点供刚蹲的朋友参考。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=a%20warm%20flat%20editorial%20illustration%20of%20an%20unfurling%20long%20paper%20scroll%20timeline%20with%20marked%20dot%20nodes%20connected%20by%20a%20line%20and%20small%20flag%20markers%2C%20on%20warm%20cream%20paper%20background%2C%20vermilion%20red%20and%20amber%20gold%20ink%20palette%2C%20cozy%20vector%20style%2C%20consistent%20warm%20tones%2C%20clean%20composition&width=720&height=540&seq=gua-feed-07&orientation=landscape',
    trust: '实锤',
    recommend: true,
  },
  {
    id: 'a8',
    tag: '后续猜测',
    time: '五天前 20:11',
    title: '剧情还能怎么走？三种走向成为蹲友们热议焦点',
    excerpt:
      '在下一波实锤到来前，网友围绕事件的后续走向展开了大量推演，其中三种可能性获得了最高的支持率。',
    body: [
      '正片阶段的种种疑点让网友对「结局」充满好奇。综合目前双方透露的信息，热门的后续走向推测大致收敛为三种：一是双方在澄清后逐渐降温、和平收场；二是新的关键证据浮出水面，剧情再度反转；三是事件进入漫长的拉锯，热度随新料起起落落。',
      '需要强调的是，以上都只是网友推演，不代表真实走向。最可靠的方式仍是以官方通报与双方正式回应为准，我们也会第一时间同步最新进展。',
    ],
    image:
      'https://readdy.ai/api/search-image?query=a%20warm%20flat%20editorial%20illustration%20of%20a%20crystal%20ball%20with%20a%20large%20question%20mark%20swirling%20inside%20and%20three%20small%20path%20arrows%20branching%20out%20around%20it%2C%20on%20warm%20cream%20paper%20background%2C%20vermilion%20red%20and%20amber%20gold%20ink%20tones%2C%20cozy%20vector%20style%2C%20consistent%20warm%20palette%2C%20clean%20composition&width=720&height=540&seq=gua-feed-08&orientation=landscape',
    trust: '网友分析',
  },
];

export const timelineNodes = [
  { time: '第 1 天', date: '事件初曝', title: '88事件首次进入大众视野', desc: '一段互动截图被大量转发，事件热度开始攀升。' },
  { time: '第 3 天', date: '正式出圈', title: '相关词条登上多平台热搜', desc: '二次讨论与梳理内容爆发，事件从圈内蔓延至更大范围。' },
  { time: '第 5 天', date: '首轮回应', title: '当事一方首次发声', desc: '就部分争议作出回应，但细节表述随后引发新的讨论。' },
  { time: '第 7 天', date: '关键录音', title: '录音片段流出并引发反转', desc: '片段化传播引发误读，完整语境仍在持续还原中。' },
  { time: '第 9 天', date: '降温与回炉', title: '热度回落，旧内容二次传播', desc: '「续集」说法被证实多为旧内容误传，网友回归理性。' },
  { time: '第 11 天', date: '二次发声', title: '当事一方承认表述不当', desc: '态度松动但核心立场未变，舆论出现中间声音。' },
  { time: '第 13 天', date: '新变量浮现', title: '新线索与旧截图被重新翻出', desc: '讨论回到最初起点，事件走向出现新的不确定性。' },
];